import {
  addressRelatedColumnRoles, type ColumnsMatchUp,
} from '~/_shared/types/columnRole.enum';
import type { SpreadsheetMatchupData } from '~/_shared/types/spreadsheetData/matchupData';
import { isString } from '~/_shared/utils/typeGuards';

const isColumnSelected = (data: [string | null, boolean]): boolean => {
  return isString(data[0]);
};

export const isMatchUpLocationSelected = (matchup: ColumnsMatchUp): boolean => {
  if (
    isColumnSelected(matchup.address) ||
    isColumnSelected(matchup.city) ||
    isColumnSelected(matchup.state) ||
    isColumnSelected(matchup.zip) ||
    isColumnSelected(matchup.country) ||
    (isColumnSelected(matchup.latitude) && isColumnSelected(matchup.longitude))
  ) {
    return true;
  }

  return false;
};

export const hasAddressColumnsChangedBetweenMatchups = (matchup1: SpreadsheetMatchupData, matchup2: SpreadsheetMatchupData): boolean => (
  addressRelatedColumnRoles.some((columnRole) =>
    matchup1.categories[columnRole]?.match !== matchup2.categories[columnRole]?.match
  )
);
